// src/auth/DefaultLanding.tsx
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAccessFeatures } from './useAccessFeatures';

// Sends each user to the first area they can actually reach. Without this a
// portfolio-only or audit user bounces to /no-access on every login, with
// their real destination one tab away.
export function DefaultLanding() {
    const { features, isPending } = useAccessFeatures();

    if (isPending) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress size={24} />
            </Box>
        );
    }

    if (features.includes('assets') || features.includes('events')) {
        return <Navigate to="/markets" replace />;
    }
    if (features.includes('monitor')) {
        return <Navigate to="/monitor" replace />;
    }
    if (features.includes('portfolio')) {
        return <Navigate to="/portfolio" replace />;
    }
    return <Navigate to="/no-access" replace />;
}
